import { Poll, CreatePollRequest, VotePollRequest } from '../Types/poll';
import { transformDateStringPropsToDate } from '../Utils/dateUtils';
import { get, post, httpDelete, getQSFromObject } from './common';
import { ObjectType } from '../Types/base';

const pollEndpoint = 'api/poll';

const mapPoll = (item: Poll | null): Poll | null => {
	if (!item) return null;
	return transformDateStringPropsToDate(item, ['CreationDate', 'DateStart', 'DateExpires']);
};

const pollArrayMapper = (items: Poll[]): Poll[] => {
	return items.map(mapPoll).filter((item): item is Poll => item !== null);
};

export async function getPollsForObject(options: { objectType: ObjectType; objectId: number }) {
	const endpoint = `${pollEndpoint}/GetPollsForObject?${getQSFromObject(options)}`;
	const result = await get<Poll[]>(endpoint);
	return result ? pollArrayMapper(result) : [];
}

export async function getOnePoll(pollId: number) {
	const endpoint = `${pollEndpoint}/GetOnePoll?${getQSFromObject({ pollId })}`;
	const result = await get<Poll>(endpoint);
	return result ? mapPoll(result) : null;
}

export async function createPoll(poll: CreatePollRequest) {
	const endpoint = `${pollEndpoint}/CreatePoll`;
	const result = await post<Poll>(endpoint, poll);
	return result ? mapPoll(result) : null;
}

export async function updatePoll(poll: Poll) {
	const endpoint = `${pollEndpoint}/UpdatePoll`;
	const result = await post<Poll>(endpoint, poll);
	return result ? mapPoll(result) : null;
}

export async function deletePoll(pollId: number) {
	const endpoint = `${pollEndpoint}/DeletePoll?${getQSFromObject({ pollId })}`;
	await httpDelete(endpoint);
}

export async function votePoll(voteRequest: VotePollRequest) {
	const endpoint = `${pollEndpoint}/Vote`;
	const result = await post<Poll>(endpoint, voteRequest);
	return result ? mapPoll(result) : null;
}

export async function togglePollActive(pollId: number) {
	const endpoint = `${pollEndpoint}/ToggleActive`;
	const result = await post<Poll>(endpoint, { pollId });
	return result ? mapPoll(result) : null;
}